(() => {
  const gate = document.querySelector('[data-aag]');
  if (!gate) return;

  const mode = gate.dataset.mode || 'full';
  const key = 'aamplified-drop-access';
  const rawCode = gate.dataset.accessCode || '';
  const code = rawCode.trim().toLowerCase();

  // Belt-and-braces: the inline bootstrap script rendered right after the gate markup
  // already hides it before first paint for a returning, already-unlocked Drop Lock
  // visitor. This is a fallback in case that inline script is ever stripped.
  if (mode === 'drop' && code && sessionStorage.getItem(key) === 'granted') {
    gate.remove();
    document.documentElement.classList.add('aag-unlocked');
    return;
  }

  if (gate.querySelector('.aag__success')) gate.classList.add('is-success');

  let mx = 0, my = 0, tx = 0, ty = 0, raf = 0;
  const motion = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tick = () => {
    mx += (tx - mx) * 0.06;
    my += (ty - my) * 0.06;
    gate.style.setProperty('--aag-mx', mx.toFixed(3));
    gate.style.setProperty('--aag-my', my.toFixed(3));
    raf = requestAnimationFrame(tick);
  };
  if (motion) {
    addEventListener('pointermove', (e) => {
      tx = e.clientX / innerWidth - 0.5;
      ty = e.clientY / innerHeight - 0.5;
    }, { passive: true });
    raf = requestAnimationFrame(tick);
  }

  // Reveal-the-private-key-field toggle
  const toggle = gate.querySelector('[data-aag-code-toggle]');
  const panel = gate.querySelector('[data-aag-code-panel]');
  toggle?.addEventListener('click', () => {
    panel.hidden = !panel.hidden;
    toggle.setAttribute('aria-expanded', String(!panel.hidden));
    if (!panel.hidden) panel.querySelector('input')?.focus();
  });

  // Single form handles email + optional phone + optional private key together.
  // - No code typed: submits natively (email/phone captured, Shopify handles the reload).
  // - Correct code typed: unlock immediately (no waiting on the reload) and still let the
  //   native submit continue in the background so the email/phone get captured too.
  // - Wrong code typed: stop the submit, show the inline error, let them retry or clear
  //   the code and submit with just their email instead.
  const form = gate.querySelector('#AaxAccessForm');
  const codeInput = gate.querySelector('[data-aag-code-input]');
  const codeWrap = gate.querySelector('[data-aag-code]');
  const err = gate.querySelector('[data-aag-code-error]');

  form?.addEventListener('submit', (e) => {
    if (mode !== 'drop' || !code || !codeInput) return;
    const entered = (codeInput.value || '').trim().toLowerCase();
    if (!entered) return; // no code entered — let the email-only submit proceed normally

    if (entered === code) {
      sessionStorage.setItem(key, 'granted');
      gate.classList.add('is-unlocking');
      document.documentElement.classList.add('aag-unlocked');
      // Do not preventDefault: the native submit still runs so the email/phone (if filled
      // in) are captured exactly like any other gate submission.
      return;
    }

    e.preventDefault();
    if (err) err.hidden = false;
    codeWrap?.classList.remove('is-error');
    void codeWrap?.offsetWidth;
    codeWrap?.classList.add('is-error');
  });

  // Soft Lock escape hatch + Full Lock "add to calendar" are plain links — no JS needed
  // for Soft Lock. Full Lock's calendar link is built here from the launch date.
  const gcal = gate.querySelector('[data-aag-gcal]');
  if (gcal) {
    const launch = gcal.dataset.launch;
    const t = Date.parse(launch || '');
    if (!Number.isNaN(t)) {
      const start = new Date(t);
      const end = new Date(t + 60 * 60 * 1000);
      const fmt = (d) => d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
      const title = encodeURIComponent(gcal.dataset.title || 'AAMPLIFIED — Access opens');
      const dates = `${fmt(start)}/${fmt(end)}`;
      gcal.href = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${dates}`;
    } else {
      gcal.remove();
    }
  }

  const countdown = gate.querySelector('[data-aag-countdown]');
  const launch = gate.dataset.launch;
  if (countdown && launch) {
    const target = Date.parse(launch);
    if (!Number.isNaN(target)) {
      const update = () => {
        const diff = Math.max(0, target - Date.now());
        const days = Math.floor(diff / 864e5);
        const hours = Math.floor((diff % 864e5) / 36e5);
        const mins = Math.floor((diff % 36e5) / 6e4);
        const secs = Math.floor((diff % 6e4) / 1e3);
        countdown.textContent = diff
          ? `${String(days).padStart(2, '0')}D / ${String(hours).padStart(2, '0')}H / ${String(mins).padStart(2, '0')}M / ${String(secs).padStart(2, '0')}S`
          : 'ACCESS WINDOW OPEN';
      };
      update();
      setInterval(update, 1000);
    }
  }

  addEventListener('pagehide', () => raf && cancelAnimationFrame(raf), { once: true });
})();